import React from 'react';
import ReactDOM from 'react-dom/client';
import TaskTracker from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <TaskTracker />
  </React.StrictMode>
);